<script lang="ts">
	import type { NotificationType } from '$lib/shared/lib/notificationStore';

	interface Props {
		message?: string;
		show?: boolean;
		type?: NotificationType;
		dismissible?: boolean;
		bannerHeight?: number;
		onclose?: () => void;
	}

	let {
		message = 'Important announcement',
		show = $bindable(true),
		type = 'info',
		dismissible = true,
		bannerHeight = $bindable(0),
		onclose
	}: Props = $props();

	let bannerElement: HTMLDivElement = $state()!;

	// DOM-ref side effect (per PATTERNS § $:-side-effect-callout): must be $effect, NOT $derived.
	$effect(() => {
		if (bannerElement) {
			bannerHeight = bannerElement.offsetHeight;
		}
	});

	function closeBanner() {
		show = false;
		onclose?.();
	}

	let typeClass = $derived(
		{
			error: 'bg-error-500 text-white',
			warning: 'bg-warning-500 text-black',
			info: 'bg-primary-500 text-white'
		}[type] || 'bg-primary-500 text-white'
	);
</script>

{#if show}
	<div bind:this={bannerElement} class="notification-banner {typeClass}">
		<div class="banner-content">
			<!-- eslint-disable-next-line svelte/no-at-html-tags -- message is composed in `notificationBanner.showError/showWarning/showInfo()` callers from server-controlled stream.tag + fixed admin-authored copy with embedded <a> tags. No untrusted user input flows into this prop. -->
			<span>{@html message}</span>
			{#if dismissible}
				<button onclick={closeBanner} class="close-btn" aria-label="Close notification">×</button>
			{/if}
		</div>
	</div>
{/if}

<style>
	.notification-banner {
		position: relative;
		width: 100%;
		z-index: 50;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
		transition: all 0.3s ease;
	}

	.banner-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 20px;
		gap: 1rem;
	}

	.close-btn {
		background: none;
		border: none;
		color: inherit;
		font-size: 24px;
		cursor: pointer;
		padding: 0 8px;
		opacity: 0.8;
		transition: opacity 0.2s;
	}

	.close-btn:hover {
		opacity: 1;
	}
</style>
